<template>
  <div class="chaptering-container h-inherit pointer disable-selection"  style="position: relative; height: 100%">
    <div class="col-12 text-center bg-sidebar text-white font-weight-bold">
      {{ $t('UI_INSTANCE_MODES_READ_ONLY') }}
    </div>

    <div class="row no-gutters" style="position: relative; height: auto">

      <div id="readOnlyOverlayInner"></div>

      <div v-for="chapter in chapters" :key="chapter.id" class="one-chapter col-lg-12">
        <!-- Chapter -->
        <div class="row no-gutters"
             :class="{
                        selectedChapter: ($store.getters.getSelectedChapterId === chapter.id) && ($store.getters.getSelectedEntryId === null),
                        setAsCurrent: isSelectedChapter(chapter),
                        currentTimestamp: $store.state.currentVideoTimestamp === chapter.timestamp  && $store.state.currentVideoTimestamp !== 0
                        }">
          <!-- Chapter Timpestamp -->
          <div class="col-lg-3 col-md-4 col-5 pt-2 br text-center timing-header">
            <h3>{{ $moment().startOf('day').seconds(chapter.timestamp).format('HH:mm:ss') }}</h3>
          </div>

          <!-- Chapter Title -->
          <div class="col-lg-9 col-md-8 col-7">
            <h3 class="chapter-header">
              {{ chapter.title }}
            </h3>
          </div>
        </div>

        <!-- Entries -->

        <div class="row no-gutters" v-for="entry in chapter.entries"
             :class="{
                     selectedEntry: $store.getters.getSelectedEntryId === entry.id,
                     setAsCurrent: isSelectedEntry(entry),
                     currentTimestamp: $store.state.currentVideoTimestamp === entry.timestamp && $store.state.currentVideoTimestamp !== 0
                     }">
          <!-- Entry Timpestamp -->
          <div class="col-lg-3 col-md-4 col-5 br text-center timing">
            <span class="">{{ $moment().startOf('day').seconds(entry.timestamp).format('HH:mm:ss') }}</span>
          </div>

          <!-- Entry Title -->
          <div class="col-lg-9 col-md-8 col-7 chapter-entry-container">
                        <span class="chapter-entry">
                            {{ entry.text }}
                        </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChapterEntryListInReadOnlyMode',
  props: ['chapters'],
  data() {
    return {};
  },
  methods: {
    /**
			 * Determines if the given chapter is the one that is currently set.
			 */
    isSelectedChapter(chapter) {
      if (!this.$store.getters.instanceInLiveMode) {
        return false;
      }
      if (this.$store.getters.instanceLiveData.currentChapter === null) {
        return false;
      }

      return chapter.id === this.$store.getters.instanceLiveData.currentChapter;
    },
    /**
			 * Determines if the given entry is the one that is currently set.
			 */
    isSelectedEntry(entry) {
      if (!this.$store.getters.instanceInLiveMode) {
        return false;
      }
      if (this.$store.getters.instanceLiveData.currentEntry === null) {
        return false;
      }

      return entry.id === this.$store.getters.instanceLiveData.currentEntry;
    },
  },
};
</script>

<style>
  .selectedChapter, .selectedEntry {
    color: white;
    background-color: #00a6d4;
    font-weight: bold;
  }

  .setAsCurrent {
    color: #e24646;
    font-weight: bold;
  }

  .currentTimestamp {
    color: #47a44b !important;
    font-weight: 800 !important;
  }

  #chapterOverlayContainer {
    position: relative;
    height: auto;
    width: 100%;
  }
</style>
